import React from 'react';
import { iconSizer } from "../../../internal/icons2022/iconSizer";
import { UiMenuDotsThreeVIcon16Light } from "../../../internal/icons2022/UiMenuDotsThreeVIcon/UiMenuDotsThreeVIcon16Light";
import { UiMenuDotsThreeVIcon20Regular } from "../../../internal/icons2022/UiMenuDotsThreeVIcon/UiMenuDotsThreeVIcon20Regular";
import { UiMenuDotsThreeVIcon24Regular } from "../../../internal/icons2022/UiMenuDotsThreeVIcon/UiMenuDotsThreeVIcon24Regular";
export var KebabIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(UiMenuDotsThreeVIcon16Light, null);
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(UiMenuDotsThreeVIcon20Regular, null);
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(UiMenuDotsThreeVIcon24Regular, null);
  }
}, 'KebabIcon');